import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { SentMessage } from '@vendasta/galaxy/chat-composer/src/chat-composer.component';
import { TranslateModule } from '@ngx-translate/core';
import { ConversationMessage } from '../../../../core/src/lib/interface/conversation.interface';
import { MessageGroup } from '../../models/message-group';
import { DefaultPosition } from '../../models/webchat-config';
import { LocationRow } from '../../models/location-row';
import { WebchatBoxComponent } from '../webchat-box/webchat-box.component';

@Component({
  selector: 'webchat-multi-location-box',
  imports: [
    GalaxyFormFieldModule,
    GalaxyLoadingSpinnerModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatInputModule,
    TranslateModule,
    WebchatBoxComponent,
  ],
  templateUrl: './webchat-multi-location-box.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./webchat-multi-location-box.component.scss'],
})
export class WebchatMultiLocationBoxComponent {
  readonly view = input<'picker' | 'chat'>('picker');
  readonly selectedLocation = input<LocationRow | null>(null);

  readonly color = input<string>('');
  readonly textColor = input<string>('');
  readonly accentColor = input<string>('');
  readonly accentTextColor = input<string>('');
  readonly welcomeMessage = input<string>('');
  readonly assistantAvatarUrl = input<string>('');
  readonly position = input<'right' | 'left'>(DefaultPosition);
  readonly showFooterContent = input<boolean>(false);
  readonly poweredByName = input<string>('');
  readonly poweredByUrl = input<string>('');

  readonly locations = input<LocationRow[]>([]);
  readonly isLoading = input<boolean>(false);
  readonly error = input<boolean>(false);
  readonly hasMore = input<boolean>(false);
  readonly hasPrev = input<boolean>(false);
  readonly currentPage = input<number>(1);
  readonly showSearch = input<boolean>(true);
  readonly embedded = input<boolean>(false);
  readonly mobile = input<boolean>(false);

  readonly currentParticipantId = input<string | null>(null);
  readonly messageGroups = input<MessageGroup[]>([]);
  readonly messages = input<ConversationMessage[]>([]);
  readonly processing = input<boolean>(false);
  readonly isReplying = input<boolean>(false);
  readonly placeholder = input<string>('');

  readonly searchChanged = output<string>();
  readonly selectLocation = output<LocationRow>();
  readonly back = output<void>();
  readonly nextPage = output<void>();
  readonly prevPage = output<void>();
  readonly closeClicked = output<void>();
  readonly retry = output<void>();
  readonly sentMessage = output<SentMessage>();

  protected onSearch(event: Event): void {
    this.searchChanged.emit((event.target as HTMLInputElement).value);
  }
}
